var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.482,
    height: 24.827,
    viewBox: "0 0 26.482 24.827",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shop",
    d: "M4.916,1.579A1.655,1.655,0,0,1,6.174,1H20.308a1.655,1.655,0,0,1,1.258.579l4.318,5.038a2.483,2.483,0,0,1,.6,1.615v.422a3.931,3.931,0,0,1-7.034,2.413,3.932,3.932,0,0,1-6.207,0,3.932,3.932,0,0,1-6.207,0A3.931,3.931,0,0,1,0,8.655V8.233A2.483,2.483,0,0,1,.6,6.618l4.32-5.04ZM7.862,8.655a2.276,2.276,0,1,0,4.552,0,.828.828,0,0,1,1.655,0,2.276,2.276,0,1,0,4.552,0,.828.828,0,0,1,1.655,0,2.276,2.276,0,1,0,4.552,0V8.233a.828.828,0,0,0-.2-.538l-4.32-5.04H6.174l-4.32,5.04a.828.828,0,0,0-.2.538v.422a2.276,2.276,0,1,0,4.552,0,.828.828,0,0,1,1.655,0ZM2.483,13.413a.828.828,0,0,1,.828.828v9.931H4.965V15.9A1.655,1.655,0,0,1,6.62,14.241h4.965A1.655,1.655,0,0,1,13.241,15.9v8.276h9.931V14.241a.828.828,0,1,1,1.655,0v9.931h.828a.828.828,0,0,1,0,1.655H.828a.828.828,0,0,1,0-1.655h.828V14.241a.828.828,0,0,1,.828-.828ZM6.62,24.172h4.965V15.9H6.62ZM14.9,15.9a1.655,1.655,0,0,1,1.655-1.655h3.31A1.655,1.655,0,0,1,21.516,15.9v4.965a1.655,1.655,0,0,1-1.655,1.655h-3.31A1.655,1.655,0,0,1,14.9,20.861Zm4.965,0h-3.31v4.965h3.31Z",
    transform: "translate(0 -1)",
    fill: "#003082"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.b8b77b5a8c2ba02d4d34a5792bab7c40.svg";
export { ForwardRef as ReactComponent };